import axios from 'axios'
import { ElMessage } from 'element-plus'

const http = axios.create({
  baseURL: 'https://www.kokoni.ltd/index',
  timeout: 6000000,
})
// 添加请求拦截器
http.interceptors.request.use(function (config) {
  config.headers = {
    'source':'integral',
    'token': localStorage.getItem('token')
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 添加响应拦截器
let isRefreshing = false
let requestQueue = []

http.interceptors.response.use(async function (response) {
    if(response.data.code === 500) {
      if(isRefreshing){
        return new Promise((resolve) => {
          requestQueue.push(() => {
            if(response.config.data){
              response.config.data = JSON.parse(response.config.data)
            }
            resolve(http.request(response.config))
          })
        })
      }else{
        const loginRes = localStorage.getItem("data")
        if(loginRes){
          let refreshRes = null
          try{
            const loginObj = JSON.parse(loginRes)
            const userCode = loginObj.data.user_code
            refreshRes = await http.post("/v3/ActionRegister/refreshToken",{account: userCode})
          }catch(err){
            return Promise.reject()
          }
          localStorage.setItem("token", refreshRes.data.token)
          isRefreshing = false
          requestQueue.forEach(cb => cb())
          requestQueue = []
          if(response.config.data){
            response.config.data = JSON.parse(response.config.data)
          }
          const res = await http.request(response.config)
          return res
        }else{
          return Promise.reject()
        }
      }
    }
    if(response.data.done) {
      return response.data
    } else {
      // ElMessage.error(response.data.msg)  // 若失败，则将错误信息给一个全局的弹窗弹出
      return response.data
    }
}, function (error) {
  return Promise.reject(error);
})


export default http;